module.exports = __webpack_public_path__ + "static/media/HeavyRain.4d63d51e.svg";